import React, { useContext } from 'react';
import { FormatPrice } from 'utils/format';
import DedicatedContractsAssignmentContext from '../context';

import { StyledCostMargin } from 'modules/assignment-cards/styled';

const calculateNetFullPrice = ({ net_full_prices = [], ...journey }) => ({
  ...journey,
  net_full_price: net_full_prices.reduce((acc, price) => acc + Number(price), 0),
});

const getSkin = (marginPercentage) => {
  if (isNaN(marginPercentage) || marginPercentage < -25) {
    return 'danger';
  } else if (marginPercentage >= -25 && marginPercentage < 0) {
    return 'warning';
  } else {
    return 'default';
  }
};

const MarginInfo = ({ id }) => {
  const { fetchingJourneys, dedicatedContractsObject, journeysByDriver } = useContext(
    DedicatedContractsAssignmentContext
  );

  const contract = dedicatedContractsObject[id];

  if (!contract) {
    return null;
  }

  const { driver, carrier, cost_per_day } = contract;

  const journeys = (journeysByDriver[driver.id] || []).map(calculateNetFullPrice);

  const journeyPrice = journeys.reduce(
    (acc, { net_full_price }) => acc + Number(net_full_price),
    0
  );

  const contractCost = Number(cost_per_day);

  const profit = journeyPrice - contractCost;
  const margin = profit / journeyPrice;
  const marginPercentage = margin * 100;

  const skin = getSkin(marginPercentage);

  if (fetchingJourneys) {
    return null;
  }

  return (
    <StyledCostMargin skin={skin} data-testid="margin_value" data-skin={skin}>
      <FormatPrice currency={carrier.currency} value={profit} />
    </StyledCostMargin>
  );
};

export default MarginInfo;
